import swal from "sweetalert";
import {CgCopy, CgEye} from "react-icons/cg";

export default function CelebrityTabCelebrityRow(props){
    var celebData=props.celebData;

    return (

        <tr className="pb-5">
            <td className="w-1/5 pb-2 pt-2">
                <div className="h-20 flex justify-center items-center">
                    <div style={{backgroundImage:`url('${celebData["imgSrc"]}')`}} className="ml-5 bg-black h-20 w-20 bg-cover bg-center rounded"/>
                </div>
            </td>

            <td className="w-1/5">
                <div className="flex text-white h-20 justify-center items-center overflow-hidden">
                    {celebData["fullName"]}
                </div>
            </td>

            <td className="w-1/5">
                <div id="no-scrollbar" className="h-20 text-white flex justify-start items-center p-2 overflow-x-scroll  ">
                    {celebData["email"]}
                </div>
            </td>

            <td className="w-1/5">
                <div className="h-20 text-white flex justify-center items-center">
                    {celebData["country"]}
                </div>
            </td>

            <td className="w-1/5">
                <div className="h-20 text-white flex justify-center items-center">
                    {celebData["dob"].toDate().getDate().toString()}-{(celebData["dob"].toDate().getMonth()+1).toString()}-{celebData["dob"].toDate().getFullYear().toString()}
                </div>
            </td>

            <td>
                <div className="h-20 flex justify-center items-center">
                    <button
                        onClick={()=>{
                            navigator.clipboard.writeText(props.id).then(function() {
                                console.log('Async: Copying to clipboard was successful!');
                            }, function(err) {
                                console.error('Async: Could not copy text: ', err);
                            });
                            swal("Copied", "Celebrity ID was copied to the clipboard", "success");
                        }}
                        className="hover:scale-105 flex justify-center items-center">
                        <CgCopy size={40} color={"black"} className="bg-white p-2 rounded"/>
                    </button>
                </div>
            </td>

            <td>
                <div className="h-20 flex justify-center items-center">
                    <button
                        onClick={()=>{
                            props.seeUserInfo()
                        }}
                        className="hover:scale-105 flex justify-center items-center">
                        <CgEye size={40} color={"black"} className="bg-white p-2 rounded"/>
                    </button>
                </div>
            </td>

        </tr>

    )
}